export const domain: string = 'muchoborwroclaw.eu.auth0.com';
export const clientId: string = 'xjnsWTkc2v8w7Xa5XqcL0hYnD0LQu7EO';
export const audience: string = 'www.muchoborwroclaw.pl/api';
